// components/Loads.js
import React from "react";
import { Spinner } from "reactstrap";

const Loader = () => (
  <div
    style={{
      height: "60vh",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }}
  >
    <Spinner style={{ width: "4rem", height: "4rem" }} color="primary" />
  </div>
);

export default Loader;